import { css } from '@emotion/css';
import React, { useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import { useDispatch, useSelector } from 'react-redux';
import { useHistory } from 'react-router-dom';
import { RootState } from '../../../features';
import { actions } from '../../../features/notification';
import { CloseButton } from '../../shared/buttons/CloseButton';
import { reveal } from '../../shared/keyframe-animations';
import { NotificationListItem } from './NotificationListItem';
import { createNotificationMessage } from './utils/createNotificationMessage';

const Empty: React.FC = () => {
  const { t } = useTranslation('notification');
  return (
    <div
      className={css`
        display: flex;
        justify-content: center;
        align-items: center;
        width: 100%;
        height: 100%;
      `}
    >
      <p>{t('empty_notification')}</p>
    </div>
  );
};

export const NotificationCenter: React.FC = () => {
  const { t } = useTranslation('notification');
  const history = useHistory();
  const dispatch = useDispatch();
  const { notifications } = useSelector((state: RootState) => state.notification);
  useEffect(() => {
    dispatch(actions.notificationCenterOpened());
  }, [dispatch]);
  const handleCloseClick = () => {
    history.goBack();
  };
  return (
    <div
      className={css`
        display: flex;
        flex-direction: column;
        justify-content: center;
        align-items: center;
        width: 100%;
        height: 100%;
        background: rgba(237, 225, 184, 0.4);
        section {
          display: flex;
          flex-direction: column;
          width: 90%;
          max-width: 480px;
          height: 95%;
          max-height: 648px;
          color: #4d3906;
          padding-bottom: calc(16px + env(safe-area-inset-bottom));
        }
        .header {
          display: flex;
          align-items: center;
          margin: 0 0 12px;
        }
        button {
          flex: 0 0 auto;
        }
        .title {
          flex: 1 1 auto;
          text-align: center;
        }
        .dummy {
          width: 44px;
          height: 44px;
        }
        .loading {
          display: flex;
          justify-content: center;
          align-items: center;
          width: 100%;
          height: 100%;
        }
        .content {
          flex: 1 1 auto;
          overflow-y: auto;
          opacity: 0;
          transform: scale(0.98) translateY(-4px);
          animation: 0.2s cubic-bezier(0.17, 0.89, 0.56, 1.72) ${reveal} both;
          animation-delay: 0.2s;
          padding: 8px;
        }
        @supports not (filter: blur(8px)) {
          background-color: #ede1b8;
        }
      `}
    >
      <section>
        <div className="header">
          <CloseButton onClick={handleCloseClick} />
          <h3 className="title">{t('top')}</h3>
          <div className="dummy" />
        </div>
        {notifications.length === 0 ? (
          <Empty />
        ) : (
          <div className="content">
            {notifications.map((item, i) => (
              <NotificationListItem
                key={i}
                type={item.type}
                message={createNotificationMessage(item, t)}
              />
            ))}
          </div>
        )}
      </section>
    </div>
  );
};
